import axiosInstance from "../helpers/axiosInstance";

export const getVendorPoApi = async (item) => {
    const url = `staff/purchaseOrder?${item}`;
    const response = await axiosInstance.get(url);
    return response.data;
};

export const createVendorPoApi = async (request) => {
    const url = `staff/purchaseOrder`;
    const response = await axiosInstance.post(url, request);
    return response.data;
};

export const getOneVendorPoApi = async (purchaseOrderId) => {
    const url = `staff/purchaseOrder/${purchaseOrderId}`;
    const response = await axiosInstance.get(url);
    return response.data;
};

export const updateVendorPoApi = async (request) => {
    const url = `staff/purchaseOrder`;
    const response = await axiosInstance.put(url, request.formData);
    return response.data;
};
